<template>
  <v-container fluid>
    <v-layout>
      <v-flex xs12 row wrap>
        <v-form>
          <v-layout row wrap>
            <v-flex xs5>
              <v-select
                :items="cryptoTraderPackagesList"
                v-model="formData.packageId"
                item-value="id"
                item-text="name"
                label="Assign package"
                @blur="$v.formData.packageId.$touch()"
                :error-messages="($v.formData.packageId.$invalid && $v.formData.packageId.$dirty) ? ['Required'] : []"
              >
              </v-select>
              <content-field
                label="Tickets count"
                v-model="formData.ticketsCount"
                :error="$v.formData.ticketsCount"
                @blur="$v.formData.ticketsCount.$touch()"
              />
              <content-field
                label="Crypto Trader Category"
                v-model="cryptoTraderCategory.badgeDisplayName"
                disabled
              />
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs3>
              <v-btn color="primary" @click.stop="receiveRegistrationLink">Get link</v-btn>
            </v-flex>
          </v-layout>
        </v-form>
      </v-flex>
    </v-layout>

    <v-dialog persistent v-model="isModalVisible" max-width="800px">
      <v-card>
        <v-card-title>
          <v-flex>
            <span>Copy invitation link</span>
            <v-layout row >
              <v-text-field
                v-model="invitationLink"
              />
              <v-btn
                fab dark  color="primary"
                v-clipboard:copy="invitationLink"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
              >
                <v-icon dark>content_copy</v-icon>
              </v-btn>
            </v-layout>
          </v-flex>
        </v-card-title>
        <v-card-actions>
          <v-btn
            color="primary"
            flat
            @click="closeModal"
          >
            close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import {required, numeric } from 'vuelidate/lib/validators'
import { mapActions, mapGetters} from 'vuex'
import { isNil, isEmpty, path } from 'ramda'

export default {
  name: "crypto-trader",
  data () {
    return {
      isModalVisible: false,
      cryptoTraderPackagesList: [],
      cryptoTraderCategory: {},
      invitationLink: '',
      formData: {
        packageId: '',
        ticketsCount: 0,
        categoryId: ''
      }
    }
  },
  computed: {
    ...mapGetters([
      'packagesList',
      'categoriesList'
    ])
  },
  validations() {
    return {
      formData: {
        ticketsCount: {
          required, numeric
        },
        packageId: { required }
      }
    }
  },
  watch: {
    packagesList: {
      handler(val) {
        if(isNil(val) || isEmpty(val)) return
        this.cryptoTraderPackagesList = val.filter((packageItem)=> packageItem.type === 'Free')
      },
      immediate: true
    },
    categoriesList: {
      handler(val) {
        if(isNil(val) || isEmpty(val)) return
        this.cryptoTraderCategory = val.find((category)=> category.categoryType === 'CryptoTrader')
        this.formData.categoryId = path(['id'], this.cryptoTraderCategory)
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions([
      'eventLink',
      'getPackagesList',
      'getCategoriesList',
      'showResultSuccessMessage',
      'showResultErrorMessage',
      'fetchCryptotraderInvitationLink'
    ]),
    onCopy () {
      this.showResultSuccessMessage('The link was added to clipboard')
    },
    onError () {
      this.showResultErrorMessage('Failed to copy link')
    },
    closeModal () {
      this.isModalVisible = false
      this.invitationLink = ''
    },
    async receiveRegistrationLink () {
      this.$v.formData.$touch()
      if (this.$v.formData.$error) return
      try {
        this.formData.ticketsCount = parseInt(path(['ticketsCount'], this.formData))
        const invitationToken = await this.fetchCryptotraderInvitationLink(this.formData)
        const encodedInvitationToken = encodeURIComponent(invitationToken)
        this.invitationLink = `${this.eventLink}registration?cryptoTraderToken=${encodedInvitationToken}`
        this.isModalVisible = true
      } catch (err) {
        throw err
      }
    },
    async receiveRequiredData () {
      await Promise.all([
        this.getPackagesList(),
        this.getCategoriesList()
      ])
    }
  },
  created () {
    this.receiveRequiredData()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/Registration/Invitation/crypto-trader.vue